import * as React from 'react';
import CategoryColorStatusView from '../../../../views/list/columns/CategoryColorStatusView';
import EntityWarning from "../../../warnings/EntityWarning";
import { IInsightsStatusData, IWarning } from '../../../../../entities/common';
import { CategoryStatusOption } from '../../../../../entities/StatusDescriptor';
import { getMultilineText, Richtext } from '../../../inputs/RichTextInput';
import { TextFormatter } from '../../../formatters/TextFormatter';

type Props = {
    entity: {
        name: string;
        statusOption: CategoryStatusOption | undefined;
        description?: string | Richtext;
        descriptionPlaceholder: string;
        insights: IInsightsStatusData | undefined
    };
    onClick: () => void;
    warnings?: IWarning[];
}

const StatusCard  = (props: Props) => {
    const { entity, warnings, onClick } = props;
    const { name, statusOption, descriptionPlaceholder } = entity;

    const description = getMultilineText(entity.description);

    return (
        <div className="card status-card" onClick={onClick} aria-hidden>
            <div className="align-center">
                <div className="title">{name}</div>
                {warnings && <EntityWarning warnings={warnings} />}
                <CategoryColorStatusView
                    statusOption={statusOption}
                    trend={entity.insights?.trend}
                />
            </div>
            <div className={`description-wrapper`} style={{ borderLeftColor: statusOption?.color }}>
                <div className={`description limited ${description ? '' : 'empty'}`} title={description}>
                    <TextFormatter value={description ?? descriptionPlaceholder} withNavigation showLinkAsIcon />
                </div>
            </div>
        </div>
    );
}

export default StatusCard;
